<template>
    <div class="searchExchange">
        <div class="searchform">
            <div class="search-item category" @click="showFilter('category')" :class="{'active':showCategorySelection}">
                <div class="search-title">物品類型</div>
                <p class="search-desc">{{album?albumGroup+album:keyword?keyword:'小卡、周邊還是手燈？'}}</p>
                <div class="member-select-form" v-if="showCategorySelection">
                    <el-radio-group v-model="category">
                        <el-radio-button v-for="(category,i) in categories" :label="category"  :value="category" :key="i"></el-radio-button>
                    </el-radio-group>
                    <div class="album-selection" v-if="category === '專卡'">
                        <el-select  v-model="albumGroup">
                            <el-option v-for="(group,i) in groups" :label="group"  :value="group" :key="i"></el-option>
                        </el-select >
                        <el-select  v-model="album" v-if="albumGroup" @change="showFilter('none')">
                            <el-option v-for="(album,i) in albums" :label="album"  :value="album" :key="i"></el-option>
                        </el-select >
                    </div>
                    <el-input class="keyword"  v-if="category && category!=='專卡'" placeholder="關鍵字" v-model="keyword" @blur="showFilter('none')" ></el-input>
                </div>
            </div>
            <div class="search-item" @click="showFilter('ownMember')" :class="{'active':showOwnMemberSelection}">
                <div class="search-title">擁有成員</div>
                <p class="search-desc">{{ownMenberSelection?ownMenberSelection:'選擇成員'}}</p>
                <div class="member-select-form" v-if="showOwnMemberSelection">
                     <el-radio-group v-model="ownMemberGroup" class="group-select">
                        <el-radio-button class="selection" v-for="(group,i) in groups" :label="group"  :value="group" :key="i"></el-radio-button>
                    </el-radio-group >
                    <div class="album-selection" v-if="ownMemberGroup">
                        <el-select  v-model="ownMenberSelection" @change="showFilter('none')">
                            <el-option v-for="(member,i) in memberList" :label="member"  :value="member" :key="i"></el-option>
                        </el-select >
                    </div>
                </div>
            </div>
            <div class="search-item" @click="showFilter('targetMember')" :class="{'active':showTargetMemberSelection}">
                <div class="search-title">欲換成員</div>
                <p class="search-desc">{{targetMemberSelection?targetMemberSelection:'選擇成員'}}</p>
                <div class="member-select-form" v-if="showTargetMemberSelection">
                    <el-radio-group v-model="ownMemberGroup" class="group-select">
                        <el-radio-button class="selection" v-for="(group,i) in groups" :label="group"  :value="group" :key="i"></el-radio-button>
                    </el-radio-group >
                    <div class="album-selection" v-if="ownMemberGroup">
                        <el-select  v-model="targetMemberSelection" @change="showFilter('none')">
                            <el-option v-for="(member,i) in memberList" :label="member"  :value="member" :key="i"></el-option>
                        </el-select >
                    </div>
                </div>
            </div>
            <div class="search" @click="doSearch()">
                <img src="../../../assets/icon/search.svg" alt="">
            </div>
           
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    data(){
        return {
            form: {
                groupName:'',
                album: '',
                category: '',
                ownMember:[],
                targetMember: [],
            },
            memberList:[],
            albums:[],
            categories:['專卡','玩偶/娃娃','官方周邊','飯制周邊'],
            ways: ['店到店','賣貨便','面交','郵寄','其他'],
            ownMemberGroup:"",
            ownMenberSelection:"",
            targetMemberGroup:"",
            targetMemberSelection:"",
            showCategorySelection: false,
            showOwnMemberSelection:false,
            showTargetMemberSelection: false,
            category:'',
            albumGroup:"",
            album:"",
            keyword:""
        }
    },
    computed:{
        ...mapState({
            groups: state => state.basic.groups,
            nctMembers: state => state.basic.nctMembers,
            nct127Members: state => state.basic.nct127Members,
            nctdreamMembers: state => state.basic.nctdreamMembers,
            wayvMembers: state => state.basic.wayvMembers,
            nctAlbums: state => state.basic.nctAlbums,
            nct127Albums: state => state.basic.nct127Albums,
            nctdreamAlbums: state => state.basic.nctdreamAlbums,
            wayvAlbums: state => state.basic.wayvAlbums,
        }),
    },
    watch:{
        'ownMemberGroup':{
            handler(newValue){
                switch(newValue){
                case 'NCT':
                    this.memberList = this.nctMembers
                    break;
                case 'NCT127':
                    this.memberList = this.nct127Members
                    break;
                case 'NCT Dream':
                    this.memberList = this.nctdreamMembers
                    break;
                case 'WayV':
                    this.memberList = this.wayvMembers
                    break;
            }
            }
        },
        'albumGroup':{
            handler(newValue){
                switch(newValue){
                case 'NCT':
                    this.albums = this.nctAlbums
                    break;
                case 'NCT127':
                    this.albums = this.nct127Albums
                    break;
                case 'NCT Dream':
                    this.albums = this.nctdreamAlbums
                    break;
                case 'WayV':
                    this.albums = this.wayvAlbums
                    break;
            }
            }
        },
        category(newValue){
        }
    },
    methods:{
        initForm(){
            this.form = {
                groupName: '',
                album: '',
                category: '',
                itemType:'',
                exchangeWay: [],
                ownMember:[],
                targetMember: [],
            }
        },
        showFilter(filter){
            this.showCategorySelection = false
            this.showOwnMemberSelection = false
            this.showTargetMemberSelection = false
            switch(filter){
                case 'category':
                    this.showCategorySelection = true
                    break;
                case 'ownMember':
                    this.showOwnMemberSelection = true
                    break;
                case 'targetMember':
                    this.showTargetMemberSelection = true
                    break;
                default:
                    break;
            }
        },
        doSearch(){

        }
    }

}
</script>

<style lang="scss" scoped>
.searchExchange {
    width: 100%;
    height: 300px;
    background: linear-gradient(98.67deg, #E1E668 18.68%, rgba(244, 254, 0, 0.23) 108.94%);
    display: flex;
    justify-content: center;
    align-items: center;
    .searchform {
        width: 900px;
        height: 60px;
        background: #FFFFFF;
        border-radius: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        position: relative;
        .search-item {
            flex: 5;
            position: relative;
            box-sizing: border-box;
            height: 100%;
            padding:15px 30px;
            box-sizing: border-box;
            .search-title{
                position: inherit;
                z-index: 2;
                font-size: 16px;
            }
            .search-desc {
                color: $textColor;
                line-height: 30px;
                position: inherit;
                z-index: 2;
                font-size: 12px;
            }
            &::after{
                content:"";
                display: block;
                width: 1px;
                height: 30px;
                background-color: #c4c4c4;
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);

            }
            &:nth-child(3){
                &::after{
                    display: none;
                }
            }
            &.active {
                position: relative;
                z-index: 2;
                .search-desc {
                    color: #FFFFFF;
                }
                &::before{
                    content:"";
                    display: block;
                    width: 325px;
                    height: 60px;
                    border-radius: 46px;
                    box-shadow: 3px 0px 20px #ccc;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%,-50%);
                    background-color: $DarkMainColor;
                    z-index: 1;
                }
                
            }
        }
        .search {
            width: 40px;
            height: 40px;
            border-radius: 20px;
            background-color:$mainColor;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 10px;
            cursor: pointer;
        }
        .member-select-form {
                position: absolute;
                top: 100px;
                background-color: #FFFFFF;
                border-radius: 20px;
                width: 420px;
                padding: 20px 30px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                box-shadow: 0 0 10px #ccc;
                .el-radio-group {
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                }
                .el-radio {
                    margin:0;
                    width: 100px;
                }
                .album-selection {
                    width: 100%;
                    .el-select {
                        width: 100%;
                        margin: 15px auto 0;
                    }
                }
                .keyword {
                    width: 100%;
                    margin: 15px auto;
                }
                /deep/ .el-radio-button__inner{
                    border-radius: 4px;
                    border: 1px solid #DCDFE6;;
                }
            }
    }
}
</style>